// extracted by mini-css-extract-plugin
export default {"editor":"VillageEditor_editor__unIrn","placementControl":"VillageEditor_placementControl__NW12D","toolBar":"VillageEditor_toolBar__WTdFd","name":"VillageEditor_name__b-DYc"};